<template>
<div class="input-container" data-component="FormInput.vue">
	<input
		class="inputText"
		required
		ref="input"
		:type="type"
		:value="modelValue"
		:name="name"
		:autocomplete="autocomplete"
		@input="$emit('update:modelValue', $event.target.value)"
		@keyup="$emit('keyup', $event.target.value)"
		@keydown="PreventKeyCode"
	>
	<span class="floating-label">{{ placeholder }}</span>
</div>
</template>

<script lang="ts">
import { onlyNumber } from '../../utilities/InputEventUtils';

export default {
	name: 'FormInput',
	props: {
		type: {
			type: String,
			default: 'text',
		},
		placeholder: String,
		name: String,
		focus: Boolean,
		modelValue: [String, Number],
		autocomplete: String,
	},
	emits: ['update:modelValue', 'keyup'],
	mounted() {
		if (this.focus) {
			this.focusInput();
		}
	},
	methods: {
		focusInput() {
			this.$refs.input.focus();
		},
		PreventKeyCode(e: any) {
			if (this.type === 'number' || this.type === 'tel') {
				if (this.type === 'tel' && e.key !== '+') onlyNumber(e);
			}
		},
		OnlyNumber(e: any) {
			onlyNumber(e);
		},
	},
};
</script>

<style scoped lang="scss">
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus {
	border: 1px solid #f07d13;
	-webkit-box-shadow: 0 0 0 1000px #fff inset;
	-webkit-text-fill-color: black;
}

.input-container {
	position: relative;
	width: 100%;

	input {
		width: 100%;
		font-size: 14px;

		&:focus {
			border-color: #f07d13;
		}
	}

	.floating-label {
		position: absolute;
		top: 18px;
		left: 12px;
		color: #979797;
		pointer-events: none;
		transition: 0.2s ease all;
	}
}

input:focus ~ .floating-label,
input:not(:focus):valid ~ .floating-label {
	z-index: 5;
	top: -9px;
	left: 10px;
	height: 20px;
	padding: 0 3px;
	background: linear-gradient(transparent 45%, #fff 20%);
	caret-color: #f07d13;
	color: #f07d13;
	font-size: 12px;
	opacity: 1;
}
</style>
